export const UserForgotPassword = {
	'Recover my password': 'Recuperar mi contraseña',
	'Enter document number or email':
		'Escribe tu número de documento o tu correo electrónico',
	'11111111-1 or youremail@company.cl': '11111111-1 o tucorreo@empresa.cl',
	'You will not be able to see this': 'No podrás ver esto',
	'Already registered? Sign in!': '¿Ya registrado? ¡Iniciar sesión!',
};
